import React, { FC, HTMLAttributes, MouseEvent, ReactNode, useCallback, useState } from 'react';
import classNames from 'classnames';
import styles from './Accordion.module.scss';
import { IconButtonWrapper } from 'components/ui';
import TooltipConfirm from 'components/TooltipConfirm/TooltipConfirm';

export interface IAccordion extends HTMLAttributes<HTMLDivElement> {
  title: string;
  extraText?: ReactNode;
  onRemove?: (e?: MouseEvent) => void;
  hasDeleteButton?: boolean;
  deleteWithoutTooltip?: boolean;
}

const Accordion: FC<IAccordion> = (props) => {
  const {
    title,
    children,
    extraText,
    className,
    hasDeleteButton,
    onRemove = () => {},
    deleteWithoutTooltip,
  } = props;
  const [showContent, setShowContent] = useState(true);
  const rootClassName = classNames(styles.root, className, {
    [styles.hide]: !showContent,
  });
  const hideButtonIcon = showContent ? 'caret-circle-up' : 'caret-circle-down';

  const handleShowContent = useCallback((e) => {
    const shouldNotExpand = e.target.parentElement.dataset.noexpand === 'true';
    if (shouldNotExpand) return;
    setShowContent((prev) => !prev);
  }, []);

  return (
    <div className={rootClassName}>
      <h3 className={styles.heading} onClick={handleShowContent} role='presentation'>
        {title}
        <TooltipConfirm
          className={styles.tooltip}
          title='tooltip.webhookDelete.title'
          text='tooltip.webhookDelete.text'
          confirmText='tooltip.webhookDelete.confirmText'
          onConfirm={onRemove}
          placement='bottom'
        >
          {hasDeleteButton && !deleteWithoutTooltip && (
            <IconButtonWrapper
              className={classNames(styles.icon, styles.trashIcon)}
              icon='trash-alt'
            />
          )}
        </TooltipConfirm>
        {extraText && extraText}
        {hasDeleteButton && deleteWithoutTooltip && (
          <IconButtonWrapper
            onClick={onRemove}
            className={classNames(styles.icon, styles.trashIcon)}
            icon='trash-alt'
            data-noexpand
          />
        )}
        <span className={classNames(`fas fa-${hideButtonIcon} ml-1`, styles.icon)} />
      </h3>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Accordion;
